__turbopack_context__.v({
  "desktopOnly": "MobileCarousel-module__GsU-KW__desktopOnly",
  "gridDesktop": "MobileCarousel-module__GsU-KW__gridDesktop",
  "mobileOnly": "MobileCarousel-module__GsU-KW__mobileOnly",
  "slick-slider": "MobileCarousel-module__GsU-KW__slick-slider",
  "spacingMobile": "MobileCarousel-module__GsU-KW__spacingMobile",
});
